var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDrivingScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9984 32.7507C27.1653 32.7507 33.7859 26.183 33.7859 18.0814C33.7859 9.97977 27.1653 3.41211 18.9984 3.41211C10.8315 3.41211 4.21094 9.97977 4.21094 18.0814C4.21094 26.183 10.8315 32.7507 18.9984 32.7507Z",
    stroke: "current",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 16.389C12.8947 11.8313 23.7936 11.9619 33.7588 16.389",
    stroke: "current",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5923 20.4863H26.5457C25.2891 20.4861 24.0757 20.9413 23.1337 21.7662C22.1916 22.5912 21.5858 23.7291 21.4301 24.966L20.5859 32.6491",
    stroke: "current",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43164 20.4863H11.3126C12.5692 20.4861 13.7825 20.9413 14.7246 21.7662C15.6666 22.5912 16.2724 23.7291 16.4282 24.966L17.2723 32.6491",
    stroke: "current",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3318 21.7167L18.878 20.3616L16.362 21.5984L16.903 18.8651L14.9404 16.8738L17.7281 16.5393L19.0304 14.0723L20.2126 16.5985L22.9804 17.0653L20.9234 18.9612L21.3318 21.7167Z",
    stroke: "current",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrivingScore);
export default __webpack_public_path__ + "static/media/ic_driving_score.6a95eef134eb9f6419cfc0aa237da8c5.svg";
export { ForwardRef as ReactComponent };